/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SummaryProviderType = {
    AzureSummarizer: 'AzureSummarizer',
    LlmSummarizer: 'LlmSummarizer'
} as const;
export type SummaryProviderType = typeof SummaryProviderType[keyof typeof SummaryProviderType];


export function instanceOfSummaryProviderType(value: any): boolean {
    for (const key in SummaryProviderType) {
        if (Object.prototype.hasOwnProperty.call(SummaryProviderType, key)) {
            if (SummaryProviderType[key as keyof typeof SummaryProviderType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SummaryProviderTypeFromJSON(json: any): SummaryProviderType {
    return SummaryProviderTypeFromJSONTyped(json, false);
}

export function SummaryProviderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryProviderType {
    return json as SummaryProviderType;
}

export function SummaryProviderTypeToJSON(value?: SummaryProviderType | null): any {
    return value as any;
}

export function SummaryProviderTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SummaryProviderType {
    return value as SummaryProviderType;
}

